// @ts-nocheck
import useAppSelector from "@insite/client-framework/Common/Hooks/useAppSelector";
import loadCurrentAccount from "@insite/client-framework/Store/Data/Accounts/Handlers/LoadCurrentAccount";
import {
    getallowBillToAddressEdit,
    getallowShipToAddressEdit,
    getCanShowInventory,
    getIsAuthenticated,
    getIsSignedInAndhasToBeSignedIn,
    getSignInRequiredToAddToCartOrSeePrices,
} from "@store/Framework/Store/Context/ContextSelector";
import { useSettingsCollection } from "@toolkit/Framework/Store/Context/ContextHooks";
import { useEffect } from "react";
import { useDispatch } from "react-redux";

export const useGreifOrderHistoryExportSettings = () => useSettingsCollection().greifOrderHistoryExportSettings;
export const useGreifInvoiceExportSettings = () => useSettingsCollection().greifInvoiceHistoryExportSettings;

export const useGetSignInRequiredToAddToCartOrSeePrices = () => {
    return useAppSelector(state => getSignInRequiredToAddToCartOrSeePrices(state));
};

export const useIsSignedInAndhasToBeSignedIn = () => {
    return useAppSelector(state => getIsSignedInAndhasToBeSignedIn(state));
};

export const useCanShowInventory = () => {
    return useAppSelector(state => getCanShowInventory(state));
};

export const useCanEditShipToAddress = () => {
    return useAppSelector(state => getallowShipToAddressEdit(state));
};

export const useCanEditBillToAddress = () => {
    return useAppSelector(state => getallowBillToAddressEdit(state));
};

export const useIsAuthenticated = () => {
    return useAppSelector(state => getIsAuthenticated(state));
};

export const useHandleLoadAccount = () => {
    const isAuthenticated = useIsAuthenticated();
    const dispatch = useDispatch();

    useEffect(() => {
        if (isAuthenticated) {
            dispatch(loadCurrentAccount());
        }
    }, [isAuthenticated]);
};
